import { render, staticRenderFns } from "./AnglijskijOnlajnVGruppe.vue?vue&type=template&id=5686ff5c&scoped=true&"
import script from "./AnglijskijOnlajnVGruppe.vue?vue&type=script&lang=js&"
export * from "./AnglijskijOnlajnVGruppe.vue?vue&type=script&lang=js&"
import style0 from "./AnglijskijOnlajnVGruppe.vue?vue&type=style&index=0&id=5686ff5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5686ff5c",
  null
  
)

export default component.exports